(function (){
    const redButt = $('#notificationFB');

    redButt.click(function () {
        location.href = "/enterPage.html";
    })
}())